<template>
    <div class="modal">
        <div class="modal__overlay" v-on:click="$emit('close')"></div>
        <div class="modal__box">
            <div class="modal__close-button" v-on:click="$emit('close')">
                <div class="modal__close-icon">
                    <IconX></IconX>
                </div>
            </div>
            <div class="modal__box-inner" id="modal-scroll">
                <div class="modal__main">
                    <component :is="currentComponent" v-bind:args="modalArguments"></component>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ScheduleModal from './modals/ScheduleModal.vue'
    import TravelModal from './modals/TravelModal.vue'
    import IconX from '../../images/icon-x.svg'

    export default {

        components: {
            ScheduleModal,
            TravelModal,
            IconX
        },

        data: function() {
            return {
                state: null
            }
        },

        props: [
            'currentComponent',
            'modalArguments'
        ],

        methods: {

        },

        created: function() {

        },

        watch: {
            currentComponent: function(val) {
                console.log(val);
            }
        }


    }
</script>


// WEBPACK FOOTER //
// Modal.vue?0faabac2